import React from 'react';
import { Plus, Download, BarChart3, FileText , LayoutDashboard } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const QuotationHeader = ({ stats, onNewQuotation }) => {
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(amount);
    };

    const navigate = useNavigate();

    const statCards = [
        {
            title: 'Total Quotations',
            value: stats.total,
            icon: FileText,
            color: '#1e40af',
            bgColor: '#eff6ff'
        },
        {
            title: 'Approved',
            value: stats.approved,
            icon: BarChart3,
            color: '#059669',
            bgColor: '#ecfdf5'
        },
        {
            title: 'Pending',
            value: stats.pending,
            icon: FileText,
            color: '#f59e0b',
            bgColor: '#fffbeb'
        },
        {
            title: 'Total Revenue',
            value: formatCurrency(stats.revenue),
            icon: BarChart3,
            color: '#059669',
            bgColor: '#ecfdf5'
        }
    ];

    return (
        <div style={{ marginBottom: '32px' }}>
            {/* Header Section */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginBottom: '24px',
                flexWrap: 'wrap',
                gap: '16px'
            }}>
                <div>
                    <h1 style={{
                        fontSize: '32px',
                        fontWeight: '700',
                        color: '#1f2937',
                        margin: '0 0 8px 0'
                    }}>
                        Quotation Management
                    </h1>
                    <p style={{
                        fontSize: '16px',
                        color: '#6b7280',
                        margin: 0
                    }}>
                        Manage quotations, track approvals, and export reports for UNITECH IKK
                    </p>
                </div>

                        <div style={{
                            display: 'flex',
                            gap: '12px',
                            flexWrap: 'wrap'
                        }}>
                            <button
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '12px 20px',
                        backgroundColor: 'white',
                        color: '#374151',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px',
                        fontSize: '14px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                    }}
                    onClick={() => navigate('/dashboard')}
                    onMouseOver={(e) => {
                        e.target.style.backgroundColor = '#f9fafb';
                        e.target.style.borderColor = '#9ca3af';
                    }}
                    onMouseOut={(e) => {
                        e.target.style.backgroundColor = 'white';
                        e.target.style.borderColor = '#d1d5db';
                    }}
                >
                    <LayoutDashboard  size={18} />
                    Dashboard
                </button>

                    <button
                        onClick={onNewQuotation}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '12px 20px',
                            backgroundColor: '#1e40af',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                        }}
                        onMouseOver={(e) => {
                            e.target.style.backgroundColor = '#1d4ed8';
                            e.target.style.transform = 'translateY(-1px)';
                            e.target.style.boxShadow = '0 4px 12px rgba(30, 64, 175, 0.3)';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.backgroundColor = '#1e40af';
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                        }}
                    >
                        <Plus size={18} />
                        New Quotation
                    </button>

                    <button
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '12px 20px',
                            backgroundColor: 'white',
                            color: '#374151',
                            border: '1px solid #d1d5db',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseOver={(e) => {
                            e.target.style.backgroundColor = '#f9fafb';
                            e.target.style.borderColor = '#9ca3af';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.backgroundColor = 'white';
                            e.target.style.borderColor = '#d1d5db';
                        }}
                    >
                        <Download size={18} />
                        Export All
                    </button>

                    <button
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '12px 20px',
                            backgroundColor: 'white',
                            color: '#374151',
                            border: '1px solid #d1d5db',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseOver={(e) => {
                            e.target.style.backgroundColor = '#f9fafb';
                            e.target.style.borderColor = '#9ca3af';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.backgroundColor = 'white';
                            e.target.style.borderColor = '#d1d5db';
                        }}
                    >
                        <BarChart3 size={18} />
                        Reports
                    </button>
                </div>
            </div>

            {/* Stats Cards */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '20px'
            }}>
                {statCards.map((stat, index) => {
                    const IconComponent = stat.icon;
                    return (
                        <div
                            key={index}
                            style={{
                                backgroundColor: 'white',
                                padding: '24px',
                                borderRadius: '12px',
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                border: '1px solid #e5e7eb',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '16px'
                            }}>
                                <div
                                    style={{
                                        width: '48px',
                                        height: '48px',
                                        borderRadius: '12px',
                                        backgroundColor: stat.bgColor,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <IconComponent size={24} color={stat.color} />
                                </div>
                            </div>

                            <div>
                                <p style={{
                                    fontSize: '32px',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    margin: '0 0 4px 0',
                                    lineHeight: '1'
                                }}>
                                    {stat.value}
                                </p>
                                <p style={{
                                    fontSize: '14px',
                                    color: '#6b7280',
                                    margin: 0,
                                    fontWeight: '500'
                                }}>
                                    {stat.title}
                                </p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default QuotationHeader;